import React from "react";
import { Grid, TextField, Paper, Button, Box } from "@mui/material";
import { isError, getErrorMsg } from "../../helper/FormHelper.jsx";
import FormContent from "./orgGrpFormSchema.jsx";

export default function OrgGrpForm({ formik, submitLabel, onSubmit }) {
  return (
    <Box component="form" sx={{ mt: 3 }}>
      <Paper sx={{ px: 3, py: 5 }} elevation={3}>
        <Grid container rowSpacing={3} columnSpacing={2}>
          {FormContent.FormControl.map((item, index) => {
            const gridStyle = "size" in item ? item.size : { xs: 12 };
            const formControlProps = item.props;

            return (
              <Grid item key={`form-section-${index}`} {...gridStyle}>
                <TextField
                  {...formControlProps}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  error={isError(formik, formControlProps.id)}
                  helperText={getErrorMsg(formik, formControlProps.id)}
                  value={formik.values[formControlProps.id] ?? ""}
                  fullWidth
                />
              </Grid>
            );
          })}
          <Grid item xs={12}>
            <Button
              variant="contained"
              onClick={onSubmit}
              disabled={!formik.isValid}
            >
              {submitLabel}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}
